module.exports = __webpack_public_path__ + "static/media/icon_event_own_goal.303cf4f9.svg";